<ng-container *ngIf="accessLoadComplete">
  <ng-container
    *ngIf="
      firmLabsAccess == 'EA' ||
      firmLabsAccess == 'Labs & EA' ||
      labsPageService.labsUser.is_sellside
    "
  >
    <div class="labs-dashboard-container">
      <div class="dashboard-leftpannle" nz-col [nzSpan]="6">
        <div class="container">
          <div nz-row class="margin_bottom_10">
            <!-- <div class="sub-heading bold line_height_1">
              About VA Labs
            </div> -->

            <div class="margin_bottom_5"></div>

            <div class="margin_bottom_5">
              <label class="font_11 line_height_1">
                VA Labs provides an opportunity for you to help shape the future
                of Visible Alpha Insights. VA Labs is an environment for
                experimentation. We are regularly developing new reports and
                gathering feedback from users to refine which reports, data sets
                and capabilities to continue improving and supporting for our
                users’ benefit.
              </label>
            </div>
            <div class="margin_bottom_5">
              <label class="font_11 line_height_1">
                Use the Feedback button in the upper right to share your
                thoughts, or contact
                <a href="mailto:labssupport@visiblealpha.com"
                  >labssupport@visiblealpha.com</a
                >.
              </label>
            </div>
          </div>

          <div nz-row class="margin_bottom_10">
            <label class="font_11 line_height_1 ">
              Reports are organized into 3 levels:
            </label>
          </div>

          <div class="report-table">
            <div nz-row>
              <div nz-col [nzSpan]="12"></div>
              <div nz-col [nzSpan]="6">
                <label class="font_11 line_height_1 bold">
                  Data Reliable?
                </label>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="font_11 line_height_1 bold">
                  Format Stable?
                </label>
              </div>
            </div>
            <nz-divider></nz-divider>
            <div
              title="These reports have reliable content and functionality."
              nz-row
            >
              <div nz-col [nzSpan]="12">
                <div class="icon-block icon-block-ready margin_top_2">
                  <label class="success-icon">
                    <va-icon name="check-circle"></va-icon>
                    Ready to use
                  </label>
                </div>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon">
                  <va-icon name="check"></va-icon>
                </label>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon">
                  <va-icon name="check"></va-icon>
                </label>
              </div>
            </div>
            <nz-divider></nz-divider>
            <div
              title="These reports have reliable data, but features or content&#013;may be changed or removed without notice."
              nz-row
            >
              <div nz-col [nzSpan]="12">
                <div class="icon-block icon-block-testing margin_top_2">
                  <label class="warning-icon">
                    <va-icon [name]="faHourglassStart" [isFontAwesome]="true"></va-icon>
                    Still in Testing
                  </label>
                </div>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon">
                  <va-icon name="check"></va-icon>
                </label>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon bold">
                  __
                </label>
              </div>
            </div>
            <nz-divider></nz-divider>
            <div
              title="These reports are in the ideation phase.&#013;The data is under review and should not be considered reliable,&#013;and the content and features may change without notice."
              nz-row
            >
              <div nz-col [nzSpan]="12">
                <div class="icon-block icon-block-experimental margin_top_2">
                  <label class="error-icon">
                    <va-icon name="exclamation-triangle"></va-icon>
                    Experimental
                  </label>
                </div>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon bold">
                  __
                </label>
              </div>
              <div nz-col [nzSpan]="6">
                <label class="report-table-icon bold">
                  __
                </label>
              </div>
            </div>
            <nz-divider></nz-divider>
          </div>

          <div nz-row>
            <div class="heading">
              Access
            </div>
          </div>
          <div nz-row>
            <div class="sub-heading bold">
              VALabs
              <nz-switch
                [(ngModel)]="isUserLabsAccess"
                (click)="changeUserAccess(isUserLabsAccess)"
              >
              </nz-switch>
            </div>
          </div>
          <div nz-row>
            <label class="font_11 line_height_1">
              You can opt out of the program at any time by turning off this
              switch.
            </label>
          </div>
          <br />
          <div nz-row>
            <div class="sub-heading bold line_height_1">
              Change your access level
            </div>
            <div>
              <label
                *ngIf="valabsConfig.selectyouraccess != undefined"
                class="font_11 line_height_1"
              >
                You’ll always only see reports from the level you select. Click
                to change your level.
              </label>
            </div>
          </div>
          <div nz-row>
            <div
              *ngFor="let item of reportTypeList; let i = index"
              nz-col
              [nzSpan]="8"
            >
              <ng-container *ngIf="item.name == 'Prod'">
                <div
                  *ngIf="
                    accessType.userAccess != 'None';
                    then if_content;
                    else else_content
                  "
                ></div>
                <ng-template #if_content>
                  <div class="access-box" (click)="selectReportType(item.id)">
                    <div class="access-box-container">
                      <div class="access-type-row" nz-row>
                        <div
                          class="access-type-box"
                          [ngClass]="
                            item.id == selectedReport
                              ? 'selected'
                              : 'unselected'
                          "
                          [ngClass]=""
                        >
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div nz-row class="alien-center">
                        <label class="font_11 line_height_1">
                          {{ item.displayname }}
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <ng-template #else_content>
                  <div class="access-box div-disable">
                    <div class="access-box-container">
                      <div class="access-type-row" nz-row>
                        <div class="access-type-box unselected">
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div nz-row class="alien-center">
                        <label class="font_11 line_height_1">
                          {{ item.displayname }}
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="item.name == 'EA'">
                <div
                  *ngIf="
                    checkUserAccessContains('EA', accessType.userAccess);
                    then if_content;
                    else else_content
                  "
                ></div>

                <ng-template #if_content>
                  <div class="access-box" (click)="selectReportType(item.id)">
                    <div class="access-box-container">
                      <div class="access-type-row" nz-row>
                        <div
                          class="access-type-box"
                          [ngClass]="
                            item.id == selectedReport
                              ? 'selected'
                              : 'unselected'
                          "
                        >
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div nz-row class="alien-center">
                        <label class="font_11 line_height_1">
                          {{ item.displayname }}
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <ng-template #else_content>
                  <div class="access-box div-disable">
                    <div class="access-box-container">
                      <div class="access-type-row" nz-row>
                        <div class="access-type-box unselected">
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div nz-row class="alien-center">
                        <label class="font_11 line_height_1">
                          {{ item.displayname }}
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="item.name == 'Labs & EA'">
                <div
                  *ngIf="
                    checkUserAccessContains('Labs & EA', accessType.userAccess);
                    then if_content;
                    else else_content
                  "
                ></div>

                <ng-template #if_content>
                  <div class="access-box" (click)="selectReportType(item.id)">
                    <div class="access-box-container">
                      <div class="access-type-row" nz-row>
                        <div
                          class="access-type-box"
                          [ngClass]="
                            item.id == selectedReport
                              ? 'selected'
                              : 'unselected'
                          "
                        >
                          {{ i + 1 }}
                        </div>
                      </div>
                      <div nz-row class="alien-center">
                        <label class="font_11 line_height_1">
                          {{ item.displayname }}
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>

                <ng-template #else_content>
                  <div
                    *ngIf="
                      checkUserAccessContains(
                        'Labs & EA',
                        accessType.firmAccess
                      );
                      then firm_if_content;
                      else firm_else_content
                    "
                  ></div>
                  <ng-template #firm_if_content>
                    <div
                      *ngIf="
                        isUserLabsAccess;
                        then user_has_access;
                        else user_not_access
                      "
                    ></div>
                    <ng-template #user_has_access>
                      <div
                        (click)="selectReportType(item.id)"
                        class="access-box"
                      >
                        <div class="access-box-container">
                          <div class="access-type-row" nz-row>
                            <div class="access-type-box unselected">
                              {{ i + 1 }}
                            </div>
                          </div>
                          <div nz-row class="alien-center">
                            <label class="font_11 line_height_1">
                              {{ item.displayname }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template #user_not_access>
                      <div class="access-box div-disable">
                        <div class="access-box-container">
                          <div class="access-type-row" nz-row>
                            <div class="access-type-box unselected">
                              {{ i + 1 }}
                            </div>
                          </div>
                          <div nz-row class="alien-center">
                            <label class="font_11 line_height_1">
                              {{ item.displayname }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-template>
                  <ng-template #firm_else_content>
                    <div
                      class="access-box div-disable"
                      title="Your firm is not enabled for level 3 access.&#013;Email labssupport@visiblealpha.com to requst access."
                    >
                      <div class="access-box-container">
                        <div class="access-type-row" nz-row>
                          <div class="access-type-box unselected">
                            {{ i + 1 }}
                          </div>
                        </div>
                        <div nz-row class="alien-center">
                          <label class="font_11 line_height_1">
                            {{ item.displayname }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="dashboard-rightpannle" nz-col [nzSpan]="24">
        <div class="container">
          <ng-container
            *ngIf="
              accessType.userAccess != 'None' ||
              labsPageService.labsUser.is_sellside
            "
          >
            <app-labs-reports
              *ngIf="
                selectedType != '' &&
                reportList.length > 0 &&
                reportTypeList.length > 0
              "
              [reportList]="reportList"
              [reportType]="selectedType"
              [reportTypeList]="reportTypeList"
            >
            </app-labs-reports>
          </ng-container>

          <div
            class="access-none"
            *ngIf="
              accessType.userAccess == 'None' &&
              !labsPageService.labsUser.is_sellside
            "
          >
            <div nz-row>
              <div class="alien-center" nz-col [nzSpan]="24">
                <label class="sub-heading">
                  You have disabled your access to VA Labs. Use the access
                  switch at the top left to re-enable your access.
                </label>
              </div>
              <div class="alien-center" nz-col [nzSpan]="24">
                <label class="sub-heading">
                  For questions, please contact us at
                  labssupport@visiblealpha.com
                </label>
              </div>
              <div class="alien-center" nz-col [nzSpan]="24">
                <a
                  class="sub-heading"
                  href="mailto:labssupport@visiblealpha.com"
                  >labssupport@visiblealpha.com</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngIf="firmLabsAccess == 'None' && !labsPageService.labsUser.is_sellside"
  >
    <app-no-access-labs
      (sendRequest)="sendAccessRequest()"
    ></app-no-access-labs>
  </ng-container>
</ng-container>
